import {
  DS_PALETTE_ITEM_SURFACES,
  type DSPaletteItemSurface,
} from "@/src/design_system/data_display/palette_item/types";

export const DS_PALETTE_ITEM_CLASSES = {
  Base: "ds-palette-item",
} as const;

export const DS_PALETTE_ITEM_SURFACE_CLASS: Record<DSPaletteItemSurface, string> = {
  [DS_PALETTE_ITEM_SURFACES.Success]: "ds-palette-item--success",
  [DS_PALETTE_ITEM_SURFACES.Warning]: "ds-palette-item--warning",
  [DS_PALETTE_ITEM_SURFACES.Danger]: "ds-palette-item--danger",
};
